import {Accordion, AccordionDetails, AccordionSummary} from "@material-ui/core";
import * as React from "react";
import appLogo from "../../assets/images/logo.png";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {NavLink, useLocation} from "react-router-dom";
import LogOut from "./LogOut";
import raiko from "../../assets/images/sidebar/raiko.svg";
import {useState} from "react";
import Exit from "./Exit";
import {useAuthState} from "../../context/AuthContext";
import {RouteInfo} from "../../route/RouteHelper";

const SidebarSmallSize = ({sideBarListItems}) => {

    const {title, total_owner} = useAuthState()

    const location = useLocation();

    function checkIsSameAddress(route) {
        return location.pathname === route
    }

    function checkHaveSameAddress(route) {
        return location.pathname.search(route) >= 0

    }

//
//     const [openModal, setOpenModal] = useState(false)
//     const changeModalState = () => {
//         setOpenModal(!openModal)
//     }
//     document.addEventListener("click", function (evt) {
//         const modalExitClickButton = document.getElementById("modalExitClickButton");
//         let targetElement = evt.target; // clicked element
//         do {
//             if (targetElement === modalExitClickButton) {
//                 return;
//             }
//             targetElement = targetElement.parentNode;
//         } while (targetElement);
//         setOpenModal(false)
//     });
    // TwoStepExit-start
    const [openDialog, setOpenDialog] = useState(false)
    const handleClickOpen = () => {
        setOpenDialog(true)
    }
    const handleClose = () => {
        setOpenDialog(false)
    }
    // TwoStepExit-end
    return (
        <div className="sidebar-small-size-content" style={{direction: "ltr"}}>
            <section className="flex-grow-1" style={{direction: "rtl"}}>
                <div className="sidebar-wrapper">
                    <div className="hero-content">
                        <img src={appLogo} alt=""/>
                        <span className="hero-title noneUserSelect w-100 text-center mt-2">سامانه مدیریت</span>
                        <span className="fs-2 mt-2 noneUserSelect w-100 text-center">{title}</span>
                    </div>
                    <ul id='sideBarContainer' style={{marginTop: "2rem"}}>
                        {total_owner &&
                        <ul>
                            <li
                                className={checkIsSameAddress(RouteInfo.generalAdmin.globalUrl) ? "item-text-active" : "item-text"}>
                                <NavLink to={RouteInfo.generalAdmin.url}>
                                    <section className={RouteInfo.generalAdmin.icon}/>
                                    <span className="sidebar-title">{RouteInfo.generalAdmin.name}</span>
                                </NavLink>
                            </li>
                        </ul>}
                        {sideBarListItems.map((item, index) => {
                            return (
                                item.child ?
                                    <Accordion
                                        className={checkHaveSameAddress(item.info.globalUrl) ? 'activeChild' : 'deActiveChild'}
                                        id='collapseSidebarContainer'>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon/>}
                                            aria-controls="panel1a-content"
                                            id="panel1a-header"
                                        >
                                            <section style={{margin: '0 9px 0 0'}} className={item.info.icon}/>
                                            <span className="child-sidebar-title">{item.info.name}</span>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <section id='sideBarChildContainer' className='d-flex flex-column'>
                                                {item.child.map((item, index) => {
                                                    return <ul>
                                                        <li key={index}
                                                            className={checkIsSameAddress(item.info.globalUrl) ? "child-item-text-active" : "child-item-text"}>
                                                            <NavLink className='w-100' style={{textAlign: "center"}}
                                                                     to={item.info.url}>
                                                                <span className='w-100'>{item.info.name}</span>
                                                            </NavLink>
                                                        </li>
                                                    </ul>
                                                })}
                                            </section>
                                        </AccordionDetails>
                                    </Accordion>
                                    :
                                    <ul>
                                        <li key={index}
                                            className={checkIsSameAddress(item.info.globalUrl) ? "item-text-active" : "item-text"}>
                                            <NavLink to={item.info.url}>
                                                <section className={item.info.icon}/>
                                                <span className="sidebar-title">{item.info.name}</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                            )
                        })}
                    </ul>
                </div>


            </section>
            {/*<section style={{height: 'unset', margin: '8px 0'}} className='logout-container'
                     onClick={handleClickOpen}
                     id="modalExitClickButton"
            >

                <section className='logout-logo'/>
                <span
                    style={{height: 'unset'}}
                    className='fs-0'
                >
                        خروج از حساب کاربری
                    </span>
            </section>
            {openModal ?
                <LogOut closeModal={setOpenModal}/> : ""}
            {
                <Exit
                    openDialog={openDialog}
                    setOpenDialog={setOpenDialog}
                    handleClickOpen={handleClickOpen}
                    handleClose={handleClose}
                />
            }*/}
            <a rel="noreferrer" target="_blank" href="https://raiko.app/" className="copyRightContent">
                <img src={raiko} alt=""/>
                <span className="copyRightTitle">2021 © Raiko.app</span>
            </a>
        </div>
    )
}
export default SidebarSmallSize



